export default function About() {
  return (
    <div className="p-8">
      <h2 className="text-3xl font-bold mb-4">About Us</h2>
      <p>
        MAS Art & General Supplies is a dynamic and forward-thinking company dedicated to delivering 
        comprehensive end-to-end business solutions. Our offerings include stationery and general office 
        supplies, ICT support services, ICT equipment and materials, electronics including laptops, as 
        well as professional printing, branding, advertising, and graphic design services.

        We strive to be a trusted one-stop solution for businesses seeking reliable office, technology, 
        and creative support. Driven by a strong commitment to quality, professionalism, and customer satisfaction, 
        we consistently deliver solutions that add value and support operational efficiency.

        Whether you require dependable ICT solutions, high-quality office supplies, or impactful branding 
        and promotional materials, MAS Art & General Supplies is equipped to deliver excellence.

        MAS Art & General Supplies is a registered company under the Malawi Business Registration 
        Act (No. 12 of 2012) and is recognized by the Government of Malawi.
      </p>
    </div>
  );
}
